import React, { useEffect, useState, useContext } from "react";
import { strings } from "../../services/Localization";
import { checkLogin } from "../../services/Login";
import { useParams } from 'react-router-dom';
import { IUser } from "../../dassTypes";
import {  dialog, dialogDescription } from '../../components/Common';
import AppContext from '../../context/AppContext'
import { BreadCrumbType, PageButtonType } from '../../datatypes/datatypes';
import { ActionType, BulkActionType, ColumnType, DataTableOption  } from '../../components/Common/DataTable/DataTypes';
import { GenericDassQuery } from "../../services/BasicDassQueries";
import { toast } from "../../utils/Toaster";
import { getVisibleActions, actionIcon, dateTimeString, prioritizedTableColumns } from "../../utils/filters";
import{ ID_INPUT_VALIDATION, DEFAULT_RECORD_LIMIT, DEFAULT_INPUT_VALIDATION }  from "../../components/Common/DataTable/DataTableConsts";
import PageContent from "../PageContent";
import { faTrashCan, faRefresh, faTrashAlt } from '@fortawesome/pro-regular-svg-icons'
import {  IMPORT_JOB_STATUS_OPTIONS } from "../../utils/consts";
import { isMobile } from "react-device-detect";
import { faListCheck } from "@fortawesome/free-solid-svg-icons";
import { ProgressBar } from "react-bootstrap";



interface IJobStates {
    loggedUser: IUser | null;
    showAlertModal: boolean;
    editUserId: string;
    pageTitle: string;
    breadCrumbArr: BreadCrumbType[];
    refresh:boolean;
    isRowDeleted?:boolean;
}

interface IRowType {

  jobUuid: string;
  status: string;
  totalRecords: number;
  successRecords: number;
  failedRecords: number;
  scheduleStarttime: string;
  scheduleEndTime: string;
}


const ImportJobs: React.FC<{}> = () => {

    const AppContextObj = useContext(AppContext);
    let { id, tabname } = useParams();
    const stateInit = {
        loggedUser: AppContextObj.user,
        pageTitle: strings.NAV_MANAGE_JOBS,
        showAlertModal: false,
        editUserId: '',
        breadCrumbArr: [{label: strings.NAV_DEVICE_MANAGEMENT, url:''}, {label: strings.NAV_MANAGE_IMPORT_JOBS, url:''}],
        refresh:false,
        isRowDeleted:false
    };

    const [importJobState, setImportJobState] = useState<IJobStates>(stateInit)

    useEffect(() => {

        if(checkLogin(AppContextObj.user)) {
            setImportJobState(prevState => { return {...prevState, loggedUser: AppContextObj.user }})
        }

    },[AppContextObj.user?.userid, importJobState.refresh])


   const getActions = () => {

        let actions: ActionType[] = [
        {
            type: "action",
            text: strings.DELETE_JOB,
            visible: () => (AppContextObj?.user?.can_register && !AppContextObj?.user?._readonly),
            render: (row, title) => actionIcon(row.jobUuid, title, faTrashAlt.iconName),
            action: (job) => deleteJob(job)
        }]


        const bulkActions: BulkActionType<IRowType>[] = [
          {
              type: "header",
              text: strings.DEFAULT_ACTIONS
          },
          {
              type: "action",
              text: strings.DELETE_JOBS,
              render: (row, title) => actionIcon(row.jobUuid, title, faTrashCan.iconName),
              action: (selectedIds) => deleteJobInBulk(selectedIds),
              visible: () => { 
                  return AppContextObj.user?.account_status === "active" 
                         && !AppContextObj.user?._readonly
                         &&  AppContextObj.user?.can_register
              } 
          }];

        return {
            actions: actions,
            bulkActions:bulkActions
        }
        
    }


    const deleteJobInBulk =  async (selectedRows: IRowType[]) => {
        // const names = selectedRows.map((row) => {
        //     return row['serviceName'];
        // })
        const jobUuids = selectedRows.map((row) => {
            return row['jobUuid'];
        })
        if(jobUuids && jobUuids.length > 0) {
            const confirmDialogeSettings = {
                title:  strings.BULK_DELETE_CONFIRM_DIALOAG_JOBS,
                description: await dialogDescription(jobUuids) + "",
                actionLabel: strings.ACTION_DELETE,
            };

            if (await dialog(confirmDialogeSettings) === true) {
                try {
                    Promise.all(jobUuids.map((jobUuid) => {
                        return GenericDassQuery("/rest/import-jobs/" + jobUuid, { method: "DELETE" });
                    })).then((values) => {
                        refreshTable(true);
                        toast.success(strings.BULK_DELETE_JOB_SUCCESS_MESSAGE);
                    });
                } catch (e) {
                    toast.error(e.message);
                }
            }
        }
    }


   const deleteJob =  async (job: IRowType) => {
        const confirmDialogeSettings = {
            title:  strings.DELETE_CONFIRM_DIALOG_JOB ,
            description: `For Job "${job.jobUuid}"`,
            actionLabel: strings.ACTION_DELETE,
        };

        if (await dialog(confirmDialogeSettings) === true) {
            try {

                Promise.resolve(GenericDassQuery("/rest/import-jobs/" + job.jobUuid, { method: "DELETE" })).then((values) => {

                    refreshTable(true);
                    toast.success(strings.DELETE_JOB_SUCCESS_MESSAGE);

                });
               
            } catch (e) {
                toast.error(e.message);
            }
        }
    }

    const renderJobProgress = (row: IRowType) => {
        const { successRecords, totalRecords, failedRecords } = row;
      
        const successPercent = (successRecords / totalRecords) * 100;
        const failPercent = (failedRecords / totalRecords) * 100;
      
        return (
          <div style={{ width: "120px" }}>
            <div className="d-flex align-items-center mb-1 text-gray fa-80">
              Total: {totalRecords}
            </div>
            <div className="d-flex align-items-center mb-1 text-success fa-75" >
              Success: {successRecords}
            </div>
            <ProgressBar now={successPercent} variant="success" style={{ height: '5px'}}  className="mb-1" />
      
            <div className="d-flex align-items-center mb-1 text-danger fa-75">
              Failed: {failedRecords}
            </div>
            <ProgressBar now={failPercent} style={{ height: '5px'}} variant="danger" />
          </div>
        );
      };
    
  
  type FilterOptionType = {
    label: string;
    value: string;
    }

  function filterJobStatus():FilterOptionType[] {
    return JSON.parse(JSON.stringify(IMPORT_JOB_STATUS_OPTIONS));
  }

   const initDataTable = () => {
        
        const {actions, bulkActions} = getActions();

        const columns: ColumnType[] = [
            {
                key: 'bulk_action_checkbox',
                type: "bulk_action_checkbox",
                title: 'Bulk Action',
                filterable: false,
                cellWidth: 3,
                newCellWidth: "30px",
                customClass: 'sticky left-first',
            },
            {
              key: 'jobUuid',
              type: "text",
              title: strings.TABLE_UUID,
              cellWidth: 3,
              newCellWidth: '320px',
              copyLink: true,
              customClass: 'font-monospace fa-80 sticky left-second',
              render_tooltip: (row) => row.jobUuid,
              filterable: true,
              filterField: "search_jobUuid",
              sortable: true,
              sortKey: "sort_by_jobUuid",
              filterType: "text",
              dataAlign: "center",
              inputValidation: ID_INPUT_VALIDATION

          },
            {
              key: "status",
              title: strings.DEVICE_JOB_STATUS,
              type: "text",
              filterable: true,
              filterField: "search_job_status",
              filterType: 'multiselect',
              inputValidation: DEFAULT_INPUT_VALIDATION,
              sortable: false,
              sortKey: "sort_by_job_status",
              cellWidth: 50,
              dataAlign:'center',
              newCellWidth: "120px",
              filterParams: {
                  mapper: (x) => {
                      return x || undefined
                  },
                  optionFetcher: filterJobStatus
              }
          }, 
          {
            key: "totalRecords",
            title: strings.JOB_PROGRESS,
            type: "text",
            filterable: false,
            filterField: "search_total_records",
            sortable: false,
            sortKey: "sort_by_total_records",
            dataAlign:'center',
            render: (row:IRowType) => renderJobProgress(row),
            newCellWidth: "180px"

          },
          {
            key: "scheduleStartTime",
            title: strings.DEVICE_JOB_SCHEDULE_STARTTIME,
            type: "text",
            filterable: true,
            filterField: "date",
            filterType: "daterange",
            inputValidation: DEFAULT_INPUT_VALIDATION,
            sortable: true,
            sortKey: "sort_by_start_time",
            filterParams: {
                startField: "from_start_date",
                endField: "to_start_date",
                mapper: (x) => x && x.format()
            },
            cellWidth: 50,
            dataAlign:'center',
            defaultSortOrder: 'desc',
            render: x => dateTimeString(x.scheduleStartTime),
            newCellWidth: "185px"
        }, 
        {
          key: "scheduleEndTime",
          title: strings.DEVICE_JOB_SCHEDULE_ENDTIME,
          type: "text",
          filterable: true,
          filterField: "date",
          filterType: "daterange",
          inputValidation: DEFAULT_INPUT_VALIDATION,
          sortable: true,
          sortKey: "sort_by_end_time",
          filterParams: {
            startField: "from_end_date",
            endField: "to_end_date",
            mapper: (x) => x && x.format()
        },
          cellWidth: 50,
          dataAlign:'center',
          render: x => dateTimeString(x.scheduleEndTime),
          newCellWidth: "185px"
      }, 
       {
              key: "errorMessage",
              title: strings.ERROR_MESSAGE,
              type: "text",
              filterable: false,
              sortable: false,
              sortKey: "sort_by_name",
              cellWidth: 50,
              dataAlign:'left',
              extraClass: 'ow-datatable-overflow-ellipsis',
              render_tooltip: (row) => row.errorMessage
          }, 
        ];

        columns.push({
            key: 'action_button',
            type: "action_button",
            title: 'Actions',
            filterable: false,
            cellWidth: 3,
            newCellWidth: "140px",
            customClass: 'sticky right',
        });

        if (isMobile) prioritizedTableColumns(['bulk_action_checkbox', 'jobuuid'], columns)

        const options:DataTableOption<IRowType> = {
            
            url:'/uiapi/rest/import-jobs',
            query_param:{ all:true, get_pages:true, limit:DEFAULT_RECORD_LIMIT, stream:'progress'},
            serial_number:false,
            id_field:'jobUuid',
            oboe_path:'pages.*',
            available_key: 'jobUuid',
            modal:false, 
            columns,
            actions: actions,
            defaultSortField: 'sort_by_start_time',
            defaultSortOrder: 'desc',
            emptyDataMsg: strings.NO_JOB_AVAILABLE,
            bulkActions: getVisibleActions(bulkActions)

        }

        return options;
    }
    
 

    const refreshTable = (isRowDeleted=false) => {

        setImportJobState(prevState => {
            return {...prevState, refresh:!prevState.refresh,isRowDeleted:isRowDeleted}
        })
        
    }
    
   const getPageButtons = () => {
        
        const pageButtons: PageButtonType[] = [
            {
              
                title: strings.REFRESH_LIST,
                action: () => { refreshTable() },
                type: 'button',
                icon: faRefresh
            },
            {
                title: strings.COLUMNS,
                action: () => { console.log(strings.ADD_USER) },
                type: 'column',
                icon: faListCheck
            }
        ];

        return pageButtons;
    }


    return (
        <PageContent
            name="import-jobs" 
            id={id} 
            tabname={tabname} 
            actions={getActions()} 
            breadCrumbArr={importJobState.breadCrumbArr} 
            pageButtons={getPageButtons()} 
            countLabel={strings.NAV_MANAGE_JOBS} 
            dataTableOption={initDataTable()} 
            isRowDeleted={importJobState.isRowDeleted}
            refresh={importJobState.refresh}>
        </PageContent>
    );

}


export default ImportJobs;
